import React, { useEffect, useState } from 'react'
import OrdineRiepilogoCardCarrello from '../../molecules/OrdineRiepilogoCardCarrello/OrdineRiepilogoCardCarrello'
import Breadcrumbs from '../../molecules/Breadcrumbs/Breadcrumbs'
import NewModal from '../../molecules/NewModal/NewModal'
import { Button, Trans } from '../../atoms'
import ModalContentQuantita from '../../organisms/ModalContentQuantita/ModalContentQuantita'
import Loading from '../../atoms/Loading/Loading'
import Link from 'next/link'
import useTrans from '../../../hooks/useTrans'
import SalvatiPerDopo from '../../organisms/SalvatiPerDopo/SalvatiPerDopo'
import ModalContentNota from '../../organisms/ModalContentNota/ModalContentNota'
import ArticoliCarrello from '../../molecules/ArticoliCarrello/ArticoliCarrello'
import { Plus } from '../../atoms/NewIcons'
import { trackingRemoveCart } from '../../../utils/gtm'

const CartTemplate = ({
  carrello_main,
  carrello_later,
  MoveToLater,
  MoveToMain,
  LoadingMain,
  Delete,
  UpdateNota,
  UpdateQuantita,
  MoveToLaterPersonalizzazione,
  MoveToMainPersonalizzazione,
  onCheckout,
  disabledCheckout,
  LoadingArticoli,
  CheckErroriCarrello,
  page,
  EliminaPersonalizzazione,
  OrdinaSubito,
  SvuotaCarrelloMain,
}) => {
  const t = useTrans()
  const [openModalNota, setOpenModalNota] = useState(false)
  const [nota, setNota] = useState(null)
  const [id, setId] = useState(null)
  const [openModalRimuovi, setOpenModalRimuovi] = useState(false)
  const [openModalQuantita, setOpenModalQuantita] = useState(false)
  const [openModalPersonalizzazione, setOpenModalPersonalizzazione] = useState(false)
  const [righeId, setRigheId] = useState()
  const [codice, setCodice] = useState(null)
  const [info_main, setInfoMain] = useState([])
  const [quantitaModificata, setQuantitaModificata] = useState(null)
  const [prossimiArriviModificata, setProssimiArriviModificata] = useState(null)
  const handleSubmit = async () => {
    nota && (await UpdateNota(nota, id), setOpenModalNota(false), setNota(null), setId(null))
  }
  const checkCarrello = (carrello_main) => {
    let righe_prenotate = []
    carrello_main.righe_carrello_merce_neutra
      .filter((item) => item.is_prenotazione == true)
      .forEach((element) => righe_prenotate.push(element))
    carrello_main.personalizzazioni_carrello.map((item) =>
      item.righe_carrello
        .filter((element) => element.is_prenotazione == true)
        .forEach((element) => righe_prenotate.push(element))
    )
    //modificare per chiedere a bea
    righe_prenotate.length > 0 &&
      setInfoMain({
        riga: {
          codice_articolo: righe_prenotate[0].articolo.codice,
          prossimo_arrivo:
            righe_prenotate[0].prossimi_arrivi[0].data +
            ' / ' +
            righe_prenotate[0].prossimi_arrivi[0].disponibilita,
        },
        type: 'prenotata',
      })
  }

  useEffect(() => {
    carrello_main && checkCarrello(carrello_main)
  }, [carrello_main])

  const handleChangeQuantita = async () => {
    UpdateQuantita(id, codice)
    setProssimiArriviModificata(null)
    setQuantitaModificata(null)
    setOpenModalQuantita(false)
  }

  const _handleRemovePersonalizzazione = (righe_id) => {
    setRigheId(righe_id)
    setOpenModalPersonalizzazione(true)
  }

  return (
    <div className="w-container" style={{ paddingBottom: 100 }}>
      <Breadcrumbs breadcrumbs={page.breadcrumbs} />
      <h1 className="cart__header">
        <Trans chiave="Carrello" />
      </h1>
      <div className="cart__container">
        <div className="cart__container__main">
          {LoadingMain || LoadingArticoli ? (
            <Loading />
          ) : carrello_main?.numero_righe !== 0 ? (
            <ArticoliCarrello
              carrello_main={carrello_main}
              info_main={info_main}
              carrelloMain={carrello_main}
              CheckErroriCarrello={CheckErroriCarrello}
              setId={setId}
              setCodice={setCodice}
              setOpenModalQuantita={setOpenModalQuantita}
              MoveToLater={MoveToLater}
              Delete={Delete}
              setOpenModalNota={setOpenModalNota}
              setNota={setNota}
              setOpenModalRimuovi={setOpenModalRimuovi}
              MoveToMainPersonalizzazione={MoveToMainPersonalizzazione}
              EliminaPersonalizzazione={_handleRemovePersonalizzazione}
              MoveToLaterPersonalizzazione={MoveToLaterPersonalizzazione}
              SvuotaCarrelloMain={SvuotaCarrelloMain}
            />
          ) : (
            <div className="articoli__carrello">
              <div className="articoli__carrello__head">
                <div className="articoli__carrello__top-buttons">
                  <Link href="/strumenti-servizi/ordine-veloce/">
                    <Button
                      className="articoli__carrello__button-import"
                      icon={<Plus />}
                      icon_pos="left"
                      label={t('Inserisci ordine tramite Excel')}
                      variant="ghost"
                      size="large"
                      responsive
                    />
                  </Link>
                </div>
              </div>
              <div className="articoli__carrello__empty">
                <p>
                  <Trans chiave="Il tuo carrello è vuoto" />
                </p>
                <Link href="/">
                  <a>
                    <Button label={t('Sfoglia prodotti')} variant="primary" size="medium" />
                  </a>
                </Link>
              </div>
            </div>
          )}
          <div className="card__preventivo__responsive">
            <OrdineRiepilogoCardCarrello
              ordine={carrello_main}
              onCheckout={onCheckout}
              disabledCheckout={disabledCheckout}
              OrdinaSubito={OrdinaSubito}
            />
          </div>
        </div>
        <SalvatiPerDopo
          carrelloLater={carrello_later}
          MoveToMain={MoveToMain}
          MoveToLater={MoveToLater}
          Delete={Delete}
          setOpenModalNota={setOpenModalNota}
          setId={setId}
          setNota={setNota}
          setCodice={setCodice}
          setOpenModalRimuovi={setOpenModalRimuovi}
          setOpenModalQuantita={setOpenModalQuantita}
          MoveToMainPersonalizzazione={MoveToMainPersonalizzazione}
          MoveToLaterPersonalizzazione={MoveToLaterPersonalizzazione}
          EliminaPersonalizzazione={_handleRemovePersonalizzazione}
        />
      </div>

      <NewModal
        visible={openModalNota}
        onClose={() => setOpenModalNota(false)}
        title={t("Inserisci note sull'articolo")}
        actions={[
          <Button
            label={t('Annulla')}
            variant="secondary"
            size="medium"
            onClick={() => setOpenModalNota(false)}
          />,
          <Button
            label={t('Conferma nota')}
            variant="primary"
            size="medium"
            onClick={handleSubmit}
          />,
        ]}
      >
        <ModalContentNota nota={nota} setNota={setNota} t={t} />
      </NewModal>

      <NewModal
        alert={true}
        visible={openModalRimuovi}
        onClose={() => setOpenModalRimuovi(false)}
        title={t('Sei sicuro di voler elimanare questo articolo?')}
        text={t('Cliccando su "Conferma e procedi" rimuoverai questo prodotto dal carrello')}
        actions={[
          <Button
            label={t('Annulla e rimani')}
            variant="primary"
            size="medium"
            onClick={() => setOpenModalRimuovi(false)}
          />,
          <Button
            label={t('Conferma e procedi')}
            variant="secondary"
            size="medium"
            onClick={() => {
              const righe_neutre = carrello_main?.righe_carrello_merce_neutra ?? []
              const righe_personalizzate =
                carrello_main?.personalizzazioni_carrello.flatMap(
                  (personalizzazione) => personalizzazione?.righe_carrello ?? []
                ) ?? []
              const righe = righe_neutre?.concat(righe_personalizzate)
              const riga = righe?.find((riga) => riga.id === id)
              trackingRemoveCart(riga ? [riga] : [])
              Delete(id)
              setId(null)
              setOpenModalRimuovi(false)
            }}
          />,
        ]}
      />

      <NewModal
        alert={true}
        visible={openModalPersonalizzazione}
        onClose={() => setOpenModalPersonalizzazione(false)}
        title={t('Sei sicuro di voler elimanare questa personalizzazione?')}
        text={t('Le righe rimarranno come merce neutra')}
        actions={[
          <Button
            label={t('Annulla e rimani')}
            variant="primary"
            size="medium"
            onClick={() => setOpenModalPersonalizzazione(false)}
          />,
          <Button
            label={t('Conferma e procedi')}
            variant="secondary"
            size="medium"
            onClick={() => {
              trackingRemoveCart(righeId)
              EliminaPersonalizzazione(righeId)
              setRigheId(null)
              setOpenModalPersonalizzazione(false)
            }}
          />,
        ]}
      />

      {openModalQuantita && (
        <ModalContentQuantita
          id={id}
          isVisible={openModalQuantita}
          setVisible={setOpenModalQuantita}
          carrello_main={carrello_main}
          SubmitChanges={handleChangeQuantita}
          setProssimiArriviModificata={setProssimiArriviModificata}
          setQuantitaModificata={setQuantitaModificata}
          qModificato={quantitaModificata}
        />
      )}
    </div>
  )
}

export default React.memo(CartTemplate)
